import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import login from '@/components/login.vue'
import register from '@/components/register.vue'
import home from '@/components/home.vue'
import main from '@/components/main/index'
import clue from '@/components/customer/clue'
import custom from '@/components/customer/custom'
import business from '@/components/customer/business'
import clueseas from '@/components/customer/clueseas'
import customseas from '@/components/customer/customseas'
import addclue from '@/components/customer/addclue'
import addbusiness from '@/components/customer/addbusiness'
import addcustom from '@/components/customer/addcustom'
import addkhlx from '@/components/customer/addkhlx'
import addkhsj from '@/components/customer/addkhsj'
import cluedetail from '@/components/customer/cluedetail'
import busdetail from '@/components/customer/busdetail'
import customdetail from '@/components/customer/customdetail'
import edit from '@/components/customer/edit'
import editbusiness from '@/components/customer/editbusiness'
import editcustom from '@/components/customer/editcustom'
import card from '@/components/toker/card'
import search from '@/components/toker/search'
import customizeclue from '@/components/toker/customizeclue'
import searvistor from '@/components/toker/searvistor'
import calltj from '@/components/data/calltj'
import businesstj from '@/components/data/businesstj'
import funnel from '@/components/data/funnel'
import follow from '@/components/data/follow'
import cluetokh from '@/components/customer/cluetokh'
import detectStatic from '@/components/data/detectStatic'
import achievement from '@/components/data/achievement'
import cardsta from '@/components/data/cardsta'
import report from '@/components/data/report'
import market from '@/components/market/index'
import shortmessage from '@/components/appalication/shortmessage'
import record from '@/components/appalication/record'
import center from '@/components/center/index'
import receivelist from '@/components/toker/receivelist'
import visitor from '@/components/toker/visitor'
import consume from '@/components/data/consume'

import wxshare from '@/components/wxshare/wxshare'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {path: '/login',name: 'login',component: login},
    {path: '/register',name: 'register',component: register},
    {path:'/',name:'home',component:home,
      children: [
        {name: 'main',path: 'main', component: main},
        {name: 'wxshare',path: 'wxshare', component: wxshare},
        {name: 'consume',path: 'consume', component: consume},
        {name: 'center',path: 'center', component: center},
        {name: 'receivelist',path: 'receivelist', component: receivelist},
        {name: 'visitor',path: 'visitor', component: visitor},
        {name: 'clue',path: 'clue', component: clue},
        {name: 'cluetokh',path: 'cluetokh', component: cluetokh},
        {name: 'custom',path: 'custom', component: custom},
        {name: 'customizeclue',path: 'customizeclue', component: customizeclue},
        {name: 'business',path: 'business', component: business},
        {name: 'clueseas',path: 'clueseas', component: clueseas},
        {name: 'customseas',path: 'customseas', component: customseas},
        {name: 'addclue',path: 'addclue', component: addclue},
        {name: 'addbusiness',path: 'addbusiness', component: addbusiness},
        {name: 'addcustom',path: 'addcustom', component: addcustom},
        {name: 'addkhlx',path: 'addkhlx', component: addkhlx},
        {name: 'addkhsj',path: 'addkhsj', component: addkhsj},
        {name: 'card',path: 'card', component: card},
        {name: 'searvistor',path: 'searvistor', component: searvistor},
        {name: 'calltj',path: 'calltj', component: calltj},
        {name: 'businesstj',path: 'businesstj', component: businesstj},
        {name: 'funnel',path: 'funnel', component: funnel},
        {name: 'follow',path: 'follow', component: follow},
        {name: 'achievement',path: 'achievement', component: achievement},
        {name: 'market',path: 'market', component: market},
        {name: 'cardsta',path: 'cardsta', component: cardsta},
        {name: 'report',path: 'report', component: report},
        {name: 'search',path: 'search', component: search},
        {name: 'shortmessage',path: 'shortmessage', component: shortmessage},
        {name: 'detectStatic',path: 'detectStatic', component: detectStatic},
        {name: 'cluedetail',path: 'cluedetail', component: cluedetail},
        {name: 'busdetail',path: 'busdetail', component: busdetail},
        {name: 'customdetail',path: 'customdetail', component: customdetail},
        {name: 'edit',path: 'edit', component: edit},
        {name: 'editbusiness',path: 'editbusiness', component: editbusiness},
        {name: 'editcustom',path: 'editcustom', component: editcustom},
        {name: 'record',path: 'record', component: record},
      ],
      redirect: {path: '/main' },
    },
  ]
})

router.beforeEach((to, from, next) => {
  console.log("token="+localStorage.getItem('token'))
  if (localStorage.getItem('token')) {
    next();
  }else{
      //没有登录，去跳转登录页
      if(to.path === '/login'){
        next();
      }else {
        next({
          path:'/login'
        });
      }
  }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js